/*
 * For font size:
 * Assume root font size: 16px
 *
 * label: 9px
 * tiny: 11px
 * small: 12px
 * semi: 13px
 * base: 14px
 * medium: 16px
 * large: 18px
 * huge: 28px
 */

const typography = {
  font_size: {
    /**
     * label: 0.5625rem / 9px
     *  */
    label: "0.5625rem", // 9px

    /**
     * tiny: 0.6875rem / 11px
     *  */
    tiny: "0.6875rem", // 11px

    /**
     * small: 0.75rem / 12px
     *  */
    small: "0.75rem", // 12px

    /**
     * small: 0.8125rem / 13px
     *  */
    semi: "0.8125rem", // 13px

    /**
     * base: 0.875rem / 14px
     *  */
    base: "0.875rem", // 14px

    /**
     * medium: 1rem / 16px
     *  */
    medium: "1rem", // 16px

    /**
     * large: 1.125rem / 18px
     *  */
    large: "1.125rem", // 18px

    /**
     * large: 1.375rem / 22px
     *  */
    xLarge: "1.375rem", // 22px

    /**
     * huge: 1.75rem / 28px
     *  */
    huge: "1.75rem", // 28px

    /**
     * huge: 2rem / 32px
     *  */
    big: "2rem" // 32px
  },
  font_weight: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 700
  },
  line_height: 1.5,
  default_font_family: "'Proxima Nova', Lato, sans-serif"
} as const;

export type FontSizeName = keyof typeof typography.font_size;
export type FontWeightName = keyof typeof typography.font_weight;

export default typography;
